import React, { useState } from 'react';
import styles from './ratings.module.scss';
import { KoButton, KoDropdown, KoForm, KoFormBuilder, KoModal, KoRating, KoText, KoTextArea, KoTitle, KoToast, KoUpload } from 'packages';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';
export default function ManageRatings({ form }) {
  const [currentForm, setCurrentForm] = useState();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [, setCurrentRecord] = useState();
  const [isopenRatingModal, setOpenRatingModal] = useState(false);

  const RatingsWidget = ({ value, onChange }) =>

    <KoRating value={value}
      onChange={v => onChange(v)}
    />;

  const Message = ({ value, onChange }) =>
    <KoTextArea
      placeholder='Enter Messages'
    />;

  const Attachemnts = ({ value, onChange }) =>
    <KoUpload
      isDnd={true}
      listType="picture"
    >
      <div className={styles.upload}>
        <p className="ant-upload-text">{`Click or drag file to this area to upload`} </p>
        <p className="ant-upload-hint">
                  Support for single or bulk uploads. Uploading banned files is strictly prohibited.
        </p>
      </div>
    </KoUpload>;


  const allForms = [
    // 1️⃣ Retail / E-Commerce
    {
      id: 1,
      name: 'Retail / E-Commerce',
      status: 1,
      forms: {
        columns: 6,
        formItemLayout: null,
        colon: true,
        fields: [
          { key: 'name', label: 'Customer Name', required: true, colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          {
            key: 'productQuality',
            label: 'Product Quality',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'deliverySpeed',
            label: 'Delivery Speed',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'packaging',
            label: 'Packaging Quality',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'valueForMoney',
            label: 'Value for Money',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'customerSupport',
            label: 'Customer Support',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Customer Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 2️⃣ SaaS / Software Product
    {
      id: 2,
      name: 'SaaS / Software',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'name', label: 'Name', required: true, colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          {
            key: 'companyName',
            label: 'Company Name',
            colSpan: 3,
            required: true
          },
          {
            key: 'role',
            label: 'User Role',
            colSpan: 3
          },
          {
            key: 'easeOfUse',
            label: 'Ease of Use',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'performance',
            label: 'Performance',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'supportExperience',
            label: 'Support Experience',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'featuresSatisfaction',
            label: 'Features Satisfaction',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'valueForSubscription',
            label: 'Value for Subscription',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Product Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 3️⃣ Healthcare / Hospital
    {
      id: 3,
      name: 'Healthcare / Hospital',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'patientName', label: 'Patient Name', required: true, colSpan: 3 },
          { key: 'appointmentId', label: 'Appointment ID', colSpan: 3 },
          { key: 'doctorName', label: 'Doctor Name', required: true, colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          {
            key: 'doctorExperience',
            label: 'Doctor Consultation',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'staffBehavior',
            label: 'Staff Behavior',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'cleanliness',
            label: 'Cleanliness',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'waitingTime',
            label: 'Waiting Time Experience',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Patient Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 4️⃣ Restaurant
    {
      id: 4,
      name: 'Restaurant',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'customerName', label: 'Customer Name', required: true, colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          {
            key: 'foodTaste',
            label: 'Food Taste',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'presentation',
            label: 'Food Presentation',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'staffService',
            label: 'Staff Service',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'ambience',
            label: 'Ambience',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'cleanliness',
            label: 'Cleanliness',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'valueForMoney',
            label: 'Value for Money',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Customer Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 5️⃣ Hospitality / Resorts / Hotel
    {
      id: 5,
      name: 'Resorts / Hotel',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'guestName', label: 'Guest Name', required: true, colSpan: 3 },
          { key: 'bookingId', label: 'Booking ID', colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          { key: 'room', label: 'Room number', colSpan: 3 },
          {
            key: 'roomAmbience',
            label: 'Room Ambience',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'foodQuality',
            label: 'Food Quality',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'housekeeping',
            label: 'Housekeeping Service',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'staffCourtesy',
            label: 'Staff Courtesy',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'recreation',
            label: 'Recreation & Activities',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Guest Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 6️⃣ Education / Training
    {
      id: 6,
      name: 'Education / Training',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'studentName', label: 'Student Name', required: true, colSpan: 3 },
          { key: 'courseName', label: 'Course / Program', required: true, colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          { key: 'staff', label: 'Trainer', colSpan: 3 },
          {
            key: 'contentQuality',
            label: 'Content Quality',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'instructorEffectiveness',
            label: 'Instructor Effectiveness',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'courseStructure',
            label: 'Course Structure',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'learningResources',
            label: 'Learning Resources',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Student Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    },

    // 7️⃣ Service / Maintenance
    {
      id: 7,
      name: 'Service / Maintenance',
      status: 1,
      forms: {
        columns: 6,
        colon: true,
        formItemLayout: null,
        fields: [
          { key: 'customerName', label: 'Customer Name', required: true, colSpan: 3 },
          { key: 'serviceId', label: 'Service Request ID', colSpan: 3 },
          { key: 'contact', label: 'Mobile / Email', required: true, colSpan: 3 },
          { key: 'flat', label: 'Flat Name / Number', colSpan: 3 },
          {
            key: 'responseTime',
            label: 'Response Time',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'technicianSkill',
            label: 'Technician Skill',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'problemResolution',
            label: 'Problem Resolution',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'communication',
            label: 'Communication',
            colSpan: 2,
            widget: RatingsWidget,
            required: true
          },
          {
            key: 'comments',
            label: 'Customer Feedback',
            widget: Message,
            colSpan: 6
          },
          {
            key: 'attachments',
            label: 'Attachments',
            widget: Attachemnts,
            colSpan: 6
          }
        ]
      }
    }
  ];

  const onCopyTicket = (row) => {
    navigator.clipboard.writeText(`${window.location.origin}/open/ticket/${getCookie("accountId")}/${row?.workspaceId}/${row?.ticketId}`);
    KoToast.success('Copied Rating Form Link');
  };
  

  return (
    <div className={styles.wrapper} onClick={() => dropdownVisible && setDropdownVisible(false)}>
      <div className={styles.formcontent}>
        {allForms.map((item, index) => (
          <div key={item.id} className={styles.formCard}  onClick={() => { setCurrentForm(item); }}>
            <div className={styles.card}>
              <div className={styles.header}>
                <div className={styles.circle}>
                  <KoIcon name="FileOutlined" height={18} width={18} />
                </div>
                <KoTitle text={item.name} level={5} />
                <KoDropdown
                  trigger={['click']}
                  open={dropdownVisible && currentForm?.id === item?.id}
                  overlayClassName={styles.settings}
                  popupRender={(menu) => (
                    <div className={styles.customDropdown} >
                      <div className={styles.customDropdownContnet}>
                        <ul>
                          <li onClick={() => { setDropdownVisible(false); setCurrentForm(item); onCopyTicket(item); }}>
                            <KoIcon name={'LinkOutlined'} />
                            <KoText text={'Copy Link'} />
                          </li>
                          <li onClick={() => { setDropdownVisible(false); setOpenRatingModal(item); }}>
                            <KoIcon name={'OpenOutlined'} />
                            <KoText text={'Preview Form'} />
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  placement={'bottomRight'}>
                  <KoButton onClick={() => { setCurrentForm(item); setDropdownVisible(true); }} type='text' icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />} className={`${styles.btn} smallBtn`} />
                </KoDropdown>
              </div>
              <div className={styles.content}>
                <KoIcon name="FormsLineOutlined" height={80} width={80} />
              </div>
            </div>

            <div className={styles.footer}>
              <div className={styles.date}>
                {/* <KoText text="Updated: " className={styles.email} /> */}

              </div>
            </div>
          </div>
        ))}
      </div>
      <KoModal
        title={`${currentForm?.name}`}
        centered
        open={isopenRatingModal}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setOpenRatingModal(false); }}
        onClose={() => { setCurrentRecord(); setOpenRatingModal(false); }}
        width={'40vw'}
        footer={[]}
      >
        <div className={styles.delWrapper}>
          <KoForm form={form} layout="vertical" >
            <KoFormBuilder form={form} meta={currentForm?.forms} layout="vertical" />
          </KoForm>
        </div>
      </KoModal>
    </div>
  );
}
